import React from "react";

const PinterestIcon = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M6.955.457c-3.498 0-6.955 2.467-6.955 6.459 0 2.539 1.35 3.984 2.168 3.984.337 0 .532-1 .532-1.277a6.148 6.148 0 0 1-.808-2.445 4.739 4.739 0 0 1 4.786-4.957 3.734 3.734 0 0 1 4.04 3.96c0 1.915-.726 5.507-3.078 5.507a1.554 1.554 0 0 1-1.575-1.58c0-1.363.9-2.683.9-4.09 0-2.387-3.2-1.955-3.2.93a4.452 4.452 0 0 0 .327 1.828c-.47 2.142-1.432 5.334-1.432 7.541 0 .682.092 1.352.153 2.034.116.137.058.123.235.054 1.718-2.488 1.657-2.975 2.434-6.232a2.724 2.724 0 0 0 2.363 1.3c3.62 0 5.247-3.733 5.247-7.1a5.94 5.94 0 0 0-6.137-5.916z" transform="translate(2.455 -.457)" fill={props.fill} /></svg>
    )
}

export default PinterestIcon;
